import { LINE_TONE, STATUS_TONE, fmtDate } from "./rxShared";
import { PhoneCall } from "lucide-react";

const COLS = ["Printed", "Sent", "Date", "Drug", "Dose", "Qty", "SIG", "Prescriber", "Refills", "Samples", "Med/Ed", "Label", "DAW", "Max dose", "Status"];
const yn = (v) => (v ? "Yes" : "No");
const td = "px-2.5 py-2 whitespace-nowrap";

function StatusCell({ rx, l }) {
  const tone = LINE_TONE[l.line_status] || STATUS_TONE[rx.status] || STATUS_TONE.draft;
  return (
    <td className={td}>
      <span className={`rounded-full px-2 py-0.5 text-[9px] font-bold uppercase tracking-wide ${tone}`}>{l.line_status}</span>
      {l.refill_cancel_pending && <span className="ml-1 inline-flex items-center gap-0.5 rounded-full bg-[#FFF3E0] px-1.5 py-0.5 text-[9px] font-bold uppercase text-[#8D5A00]" title="Call the pharmacy to cancel remaining refills"><PhoneCall size={9} /> Call pharmacy</span>}
    </td>
  );
}

function Row({ r, i, checked, focused, onCheck, onFocus, onOpen }) {
  const { rx, l } = r;
  const struck = l.line_status === "Voided" || l.line_status === "Discontinued";
  const strike = struck ? "line-through decoration-[#C62828]/50" : "";
  return (
    <tr data-testid={`rx-sheet-row-${i}`} onClick={onFocus} onDoubleClick={onOpen}
      className={`cursor-pointer border-t border-[#EFEBE0] transition-colors ${checked ? "bg-[#EFE6DA]" : i % 2 ? "bg-[#FDFCF8]" : "bg-white"} ${focused ? "outline outline-2 -outline-offset-2 outline-[#8D6E63]" : ""} hover:bg-[#F5EFE6] ${struck ? "text-[#84675B]" : "text-[#3E2723]"}`}>
      <td className="px-2.5 py-2" onClick={(e) => e.stopPropagation()}><input type="checkbox" data-testid={`rx-sheet-check-${i}`} checked={checked} onChange={onCheck} className="h-4 w-4 accent-[#4E342E]" aria-label={`Select ${l.medication}`} /></td>
      <td className={td}>{yn(l.printed)}</td><td className={td}>{yn(l.sent)}</td>
      <td className={td}><div>{fmtDate(rx.written_date || rx.signed_at || rx.created_at)}</div><div className="font-mono text-[9px] text-[#84675B]">{rx.rx_number}</div></td>
      <td className={`${td} font-semibold ${strike}`}>{l.medication}</td><td className={`${td} ${strike}`}>{l.strength}</td><td className={td}>{l.quantity}</td>
      <td className="max-w-[200px] truncate px-2.5 py-2" title={l.directions || l.frequency}>{l.directions || l.frequency}</td>
      <td className={td}>{rx.prescriber_name}</td><td className={`${td} text-center`}>{l.refills}</td>
      <td className={td}>{l.samples ? l.samples_amount || "Yes" : "No"}</td><td className={td}>{yn(l.med_ed)}</td><td className={td}>{yn(l.label)}</td>
      <td className={td}>{yn(l.daw)}</td><td className={td}>{l.max_daily_dose || "-"}</td><StatusCell rx={rx} l={l} />
    </tr>
  );
}

/** Quick Doc style table: one row per medication across every prescription for the client. */
export function RecordSheetTable({ rows, selected, focus, onToggle, onToggleAll, onFocus, onOpen }) {
  const all = rows.length > 0 && rows.every((r) => selected.has(r.key));
  return (
    <div className="max-h-[560px] overflow-auto rounded-2xl border border-[#EFEBE0]" data-testid="rx-record-sheet-table">
      <table className="min-w-full text-xs">
        <thead className="sticky top-0 z-10 bg-[#F5F2EB]">
          <tr className="text-left text-[10px] font-bold uppercase text-[#7B6157]">
            <th className="px-2.5 py-2.5"><input type="checkbox" data-testid="rx-sheet-check-all" checked={all} onChange={onToggleAll} className="h-4 w-4 accent-[#4E342E]" aria-label="Select all" /></th>
            {COLS.map((h) => <th key={h} className="whitespace-nowrap px-2.5 py-2.5">{h}</th>)}
          </tr>
        </thead>
        <tbody>
          {rows.map((r, i) => <Row key={r.key} r={r} i={i} checked={selected.has(r.key)} focused={focus === r.key}
            onCheck={() => onToggle(r.key)} onFocus={() => onFocus(r.key)} onOpen={() => onOpen(r.rx.id)} />)}
        </tbody>
      </table>
    </div>
  );
}
